import { BrowserCacheLocation, Configuration, LogLevel } from "@azure/msal-browser";
import { environment } from "src/environments/environment";
import { diag } from "./loop-diagnostics";

export const groups = {
    admin: "d7153e38-aae0-44de-9af3-30e15142745b",
    consultant: "c4b62735-3801-45da-aa06-c2f1cb2671ac"
}

export const msalConfig: Configuration = {
    auth: {
        clientId: environment.azureAdClientId, // This is the ONLY mandatory field that you need to supply.
        authority: 'https://login.microsoftonline.com/b45e6e2f-cb78-4806-9ab5-de04aab45b3e', // Defaults to "https://login.microsoftonline.com/common"
        // A bare page that only forwards Microsoft's response (see src/auth.html).
        // Must not be the app: msal-browser v5 requires the page it lands on to hand
        // the response back, which the app does not do, and pointing this at the app
        // is what put people in a login loop. Registered on the app registration.
        redirectUri: '/auth.html',
        postLogoutRedirectUri: '/', // Points to window.location.origin by default.
    },
    cache: {
        cacheLocation: BrowserCacheLocation.LocalStorage, // Configures cache location. "sessionStorage" is more secure, but "localStorage" gives you SSO between tabs.
    },
    system: {
        loggerOptions: {
            loggerCallback(logLevel: LogLevel, message: string) {
                // Into the redirect-surviving buffer (staging only, see loop-diagnostics):
                // the console is wiped by the very redirects this is meant to explain.
                diag('msal', { lvl: LogLevel[logLevel], msg: message.slice(0, 300) });
            },
            // Verbose feeds the staging diagnostics buffer; production has no reader for it.
            logLevel: environment.isStaging ? LogLevel.Verbose : LogLevel.Warning,
            // PII logging writes tokens, and this buffer is read back by hand.
            piiLoggingEnabled: false
        }
    }
}

/**
 * Add here the endpoints and scopes when obtaining an access token for protected web APIs. For more information, see:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/resources-and-scopes.md
 */
export const protectedResources = {
    apiApp: {
        endpoint: environment.azureAdProtectedResource,
        scopes: ["api://79277651-a13e-4abc-a8ce-c42db3ebc526/access_via_group_assignments"]
    },
    apiGraph: {
        endpoint: "https://graph.microsoft.com/v1.0/me/checkMemberGroups",
        scopes: ["User.Read", "GroupMember.Read.All"]
    }
}

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit:
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest = {
    scopes: [...protectedResources.apiApp.scopes]
};

export const CACHE_TTL_IN_MS = 60 * 60 * 1000; // 1 hour in milliseconds
